var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":_vm.url,"lazy-src":_vm.url,"aspect-ratio":4 / 3,"contain":"","width":"100","height":"75"}})
}
var staticRenderFns = []

export { render, staticRenderFns }